<template>
  <header class="app-header">
    <router-link class="app-header__logo" to="/dashboard">{{ projectName }}</router-link>
    <a class="app-sidebar__toggle" href="#" data-toggle="sidebar" aria-label="Hide Sidebar"></a>
    <ul class="app-nav">
      <li class="dropdown">
        <!-- Add :class binding to conditionally apply the classes -->
        <a class="app-nav__item" href="#" data-bs-toggle="dropdown" aria-label="Show notifications">
          <!-- <i :class="['bi', 'fs-5', countStatusIdOne > 0 ? 'bi-bell-fill text-danger' : 'bi-bell']"></i> -->
          <i class="bi bi-bell fs-5"></i>
          <span v-if="countStatusIdOne > 0" class="badge rounded-pill text-bg-danger navbar-badge">{{ countStatusIdOne
            }}</span>
        </a>
        <ul class="app-notification dropdown-menu dropdown-menu-right">
          <li class="app-notification__title">
            คุณมีการแจ้งเตือนใหม่.
          </li>
          <div class="app-notification__content">
            <li>
              <!-- <a class="app-notification__item" href="javascript:;">
                <span class="app-notification__icon"><i class="bi bi-exclamation-circle fs-4 text-primary"></i></span>
                <div>
                  <p class="app-notification__message">รายการจองห้องประชุม (รออนุมัติ)</p>
                  <p class="app-notification__meta">จำนวน {{ countStatusIdOne }} รายการ</p>
                </div>
              </a> -->

              <router-link to="/items" class="app-notification__item">
                <span class="app-notification__icon"><i class="bi bi-exclamation-circle fs-4 text-primary"></i></span>
                <div>
                  <p class="app-notification__message">คุณมีการแจ้งเตือน</p>
                  <p class="app-notification__meta">จำนวน {{ countStatusIdOne }} รายการ</p>
                </div>
              </router-link>
            </li>
          </div>
          <li class="app-notification__footer"><router-link to="/notifications">ดูการแจ้งเตือนทั้งหมด.</router-link>
          </li>
        </ul>
      </li>
      <li class="dropdown">
        <a class="app-nav__item" href="#" data-bs-toggle="dropdown" aria-label="Open Profile Menu">
          <i class="bi bi-person fs-4"></i>
        </a>
        <ul class="dropdown-menu settings-menu dropdown-menu-right">
          <!-- <li><router-link class="dropdown-item" to="/settings"><i
                class="bi bi-gear me-2 fs-5"></i>Settings</router-link></li> -->
          <li><router-link class="dropdown-item" to="/profile"><i
                class="bi bi-person me-2 fs-5"></i>ข้อมูลส่วนตัว </router-link></li>
          <li><a class="dropdown-item" href="#" @click.prevent="handleLogout"><i
                class="bi bi-box-arrow-right me-2 fs-5"></i>ออกจากระบบ</a></li>
        </ul>
      </li>
    </ul>
  </header>
</template>

<script>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Swal from 'sweetalert2';
import httpCommon from '@/httpCommon';
// import bookingService from '@/services/booking-service';
// import { io } from 'socket.io-client';
import { nextTick } from 'vue';

export default {
  name: 'Navbar',
  setup() {
    const store = useStore();
    const router = useRouter();

    const projectName = computed(() => store.getters.getProjectName);
    // const items = ref([]); // Holds all bookings
    const countStatusIdOne = ref(0); // Count of bookings with status_id == 1

    // Fetch bookings and filter based on status_id
    // const fetchItems = async () => {
    //   try {
    //     const res = await bookingService.getAll();  // Make a GET request
    //     items.value = res.data;

    //     // Count the number of bookings with status_id == 1
    //     countStatusIdOne.value = items.value.filter(item => item.status_id === 1).length;
    //   } catch (error) {
    //     console.error('Error fetching data:', error);
    //   }
    // };

    // // Watch for status update changes in Vuex
    // watch(
    //   () => store.getters.statusUpdated,
    //   (newVal) => {
    //     if (newVal) {
    //       fetchItems();  // Call fetchItems when the status is updated
    //       store.dispatch('updateStatus', false);  // Reset the flag
    //     }
    //   }
    // );


    // Handle Logout
    const handleLogout = async () => {
      try {
        await httpCommon.post('logout', {}, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`, // Replace with your token retrieval method
          },
        });

        Swal.fire({
          title: 'ออกจากระบบ!',
          text: 'ออกจากระบบสำเร็จ.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          // Clear user data from localStorage and store
          localStorage.removeItem('token');
          localStorage.removeItem('vuex');

          // Redirect to the login page
          router.push({ name: 'Login' });
        });
      } catch (error) {
        console.error('Logout failed:', error.response?.data?.message || 'An error occurred');
        router.push({ name: 'Login' });
      }
    };

    // const socket = io('https://socket-it-service.wanorn.com');

    // const listenForMessages = () => {
    //   socket.on('emt', () => {
    //     // fetchItems(); // Refresh the services when a message is received
    //   });
    // };

    // Fetch data when component is mounted
    onMounted(() => {
      // listenForMessages()

      // fetchItems();
      initializeJQuery();
    });

    // Cleanup when component is unmounted (disconnect from socket)
    onBeforeUnmount(() => {
      // socket.off('emt', listenForMessages); // Stop listening to the message event
      // socket.disconnect(); // Disconnect from socket server
    });


    const initializeJQuery = () => {
      nextTick(() => {
        // Toggle Sidebar
        const sidebarToggle = document.querySelector('[data-toggle="sidebar"]');
        if (sidebarToggle) {
          sidebarToggle.addEventListener('click', (event) => {
            event.preventDefault();
            document.querySelector('.app').classList.toggle('sidenav-toggled');
          });
        }

        // Activate sidebar treeview toggle
        document.querySelectorAll("[data-toggle='treeview']").forEach((el) => {
          el.addEventListener('click', (event) => {
            event.preventDefault();
            const parent = event.currentTarget.parentElement;
            if (!parent.classList.contains('is-expanded')) {
              document.querySelectorAll('.app-menu [data-toggle="treeview"]').forEach((item) => {
                item.parentElement.classList.remove('is-expanded');
              });
            }
            parent.classList.toggle('is-expanded');
          });
        });
      });
    };


    return {
      projectName,
      countStatusIdOne,
      // fetchItems,
      handleLogout,
    };
  },
};
</script>

<style scoped>
/* Add your styles here */
.app-header__logo {
  font-size: 21px;
}

.navbar-badge {
  font-size: .6rem;
  padding: 2px 4px;
  position: absolute;
  right: 5px;
  top: 9px;
}
</style>
